import { render, staticRenderFns } from "./AlbumDescriptionManager.vue?vue&type=template&id=edeea784&scoped=true&"
import script from "./AlbumDescriptionManager.vue?vue&type=script&lang=ts&"
export * from "./AlbumDescriptionManager.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edeea784",
  null
  
)

export default component.exports